import { createContext, useContext } from "react";

export interface OrganizationSearchCriteria {
    searchText: string;
    currentPage: number;
}

export interface OrganizationSearchContextParams {
    initialCriteria: OrganizationSearchCriteria;
    setCriteria: React.Dispatch<React.SetStateAction<OrganizationSearchCriteria>>;
}

const defaultOrganizationSearchCriteria: OrganizationSearchCriteria = {
    searchText: "",
    currentPage: 1,
};

const OrganizationSearchContext = createContext<OrganizationSearchContextParams>({
    initialCriteria: defaultOrganizationSearchCriteria,
    setCriteria: () => {},
});

const useOrganizationSearch = () => {
    return useContext(OrganizationSearchContext);
};

export { OrganizationSearchContext, useOrganizationSearch, defaultOrganizationSearchCriteria };
